<template>
  <Modal :open="props.open" @close-modal="$emit('close-modal')" custom-height="h-[75vh]">
    <template #modal-header>
      <div class="flex flex-col">
        <div class="flex gap-2 items-center">
          <Icon name="Pencil" class="h-4 w-4 text-info" />
          <p class="font-inter text-sm text-info font-semibold">Adding a beneficial owner</p>
        </div>
        <h3 class="font-semibold text-[28px] text-strongest">Add a new beneficial owner</h3>
      </div>
    </template>
    <template #modal-body>
      <BeneficialOwnerForm ref="beneficialOwnerFormRef" />
    </template>
    <template #modal-footer>
      <div class="w-full flex justify-end">
        <Button @click="$emit('close-modal')" variant="paper-primary" size="md" class="mr-2">
          <template #label>Cancel</template>
        </Button>
        <Button @click="handleContinue" variant="primary-grey" size="md" :disabled="isSaving">
          <template #label>
            {{ isLastSubstep ? "Confirm" : "Next" }}
          </template>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { ref, computed } from "vue";
import { Modal, Icon, Button } from "@/components";
import { usePurchaseFlowStore } from "@/stores";
import BeneficialOwnerForm from "./BeneficialOwnerForm.vue";

const purchaseFlowStore = usePurchaseFlowStore();

const emit = defineEmits(["close-modal", "save-changes"]);
const props = defineProps({
  open: { type: Boolean, required: true },
});

const beneficialOwnerFormRef = ref(null);
const isSaving = ref(false);

const isLastSubstep = computed(() => beneficialOwnerFormRef.value?.isLastSubstep ?? false);

async function handleContinue() {
  const form = beneficialOwnerFormRef.value;
  if (!form) return;

  const result = await form.validate();
  if (!result.proceed) return;

  if (form.isLastSubstep) {
    await saveContact();
  } else {
    form.goToNextSubstep();
  }
}

async function saveContact() {
  isSaving.value = true;
  try {
    await purchaseFlowStore.saveBeneficialOwner();
    emit("close-modal");
  } catch (error) {
    console.error("Error saving beneficial owner:", error);
  } finally {
    isSaving.value = false;
  }
}
</script>
